import { isEmpty } from 'lodash';

function isCaseOpen(serviceCase) {
  return isEmpty(serviceCase.outcome);
}

export default isCaseOpen;
